import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { SOFToolHttpService } from '@core/services/http';
import { getIdParamFromUrl } from '@core/utils/methods';

export class SOFToolDetailsResolver implements Resolver {
  async resolve(): Promise<void> {
    const [projectId] = getIdParamFromUrl();

    await HttpService.getHttpRequests(SOFToolHttpService).getSOFToolDetails(
      projectId,
    );
  }
}
